import createCache, { Options as OptionsOfCreateCache } from '@emotion/cache';

export type EmotionCacheOptions = Omit<OptionsOfCreateCache, 'insertionPoint'> & {
    prepend?: boolean;
};

export function createManagedCache(options: EmotionCacheOptions) {
    const cache = createCache(options);
    cache.compat = true;
    const prevInsert = cache.insert;
    let inserted: string[] = [];

    cache.insert = (...args) => {
        const serialized = args[1];
        if (cache.inserted[serialized.name] === undefined) {
            inserted.push(serialized.name);
        }

        return prevInsert(...args);
    };

    const flush = () => {
        const prevInserted = inserted;
        inserted = [];
        return prevInserted;
    };

    return { cache, flush };
}

export default createManagedCache;
